import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08c99d36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rss_activity" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = {
  key: 0,
  class: "subscribe"
}
const _hoisted_4 = { class: "subscribe-name" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消订阅")
const _hoisted_6 = { key: 1 }

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";

    interface RssActivityCompanyVo {
      id: string;
      rssCompanyId: string;
      rssCompanyCode: string;
      rssCompanyName: string;
      rssCompanyLogo: string;
      rssCompanyShortName: string;
    }

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
    const loading = ref(true)

    const bindData = reactive({
      rssActivityCompanyPageParams: {
        curPage: 1,
        pageSize: 10,
        filtrate: {
          keyword: "",
        },
      },
      rssActivityCompanyPageResult: {
        status: 2000,
        msg: "成功",
        result: [],
        totalCount: 0,
      },
    });

    const handleSizeChangeEvent = (value: any) => {
      bindData.rssActivityCompanyPageParams.pageSize = value;
      bindData.rssActivityCompanyPageParams.curPage = 1;
      searchEvent();
    };

    const handleCurrentChangeEvent = (value: any) => {
      bindData.rssActivityCompanyPageParams.curPage = value;
      searchEvent();
    };

    const searchEvent = () => {
      store
        .dispatch("subscribeModule/pageRssActivityCompanyList", bindData.rssActivityCompanyPageParams)
        .then(
          (data) => {
            //成功
            for (var index in data.result) {
              const obj = data.result[index];
              if(!obj.rssCompanyLogo||obj.rssCompanyLogo.length<=0){
                obj.rssCompanyLogo = require('@/assets/no_pict.png');
              }
            }
            bindData.rssActivityCompanyPageResult = data;
            loading.value = false;
          },
          (error) => {
            console.log(error.msg);
          }
        );
    };

    searchEvent();

   
    const deleteEvent = (row: RssActivityCompanyVo) => {
      ElMessageBox.confirm(`您确定要取消对 ${row.rssCompanyShortName} [${row.rssCompanyCode}] 的订阅吗?`)
        .then(() => {
          const params = {
            id: row.id,
          };
          store.dispatch("subscribeModule/deleteRssActivity", params).then(
            (data) => {
              //成功
              ElMessage.success("操作成功.");
              searchEvent();
            },
            (error) => {
              ElMessageBox.alert(error.msg, "系统消息", {
                confirmButtonText: "关闭",
                callback: (action: Action) => {},
              });
            }
          );
        })
        .catch(() => {
          // catch error
        });
    };

    

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "rss_activity-search" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { class: "rss_activity-search-lt" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { class: "rss_activity-search-lt-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "",
                  size: "large",
                  modelValue: _unref(bindData).rssActivityCompanyPageParams.filtrate.keyword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).rssActivityCompanyPageParams.filtrate.keyword) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "rss_activity-search-lt-btn" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  size: "large",
                  onClick: searchEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_unref(bindData).rssActivityCompanyPageResult.totalCount>0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).rssActivityCompanyPageResult.result, (item) => {
                return (_openBlock(), _createBlock(_component_el_col, { key: item }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { "body-style": "padding:20px;height:180px;position: relative;" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_image, {
                          class: "subscribe-logo",
                          src: item.rssCompanyLogo,
                          fit: "fill",
                          lazy: true
                        }, null, 8, ["src"]),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(item.rssCompanyName), 1),
                        _createVNode(_component_el_container, { class: "subscribe-btn" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElButton), {
                              type: "text",
                              onClick: ($event: any) => (deleteEvent(item))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])), [
          [_directive_loading, loading.value]
        ])
      : (_openBlock(), _createElementBlock("div", _hoisted_6, "暂无数据")),
    _createVNode(_component_el_container, { class: "rss_activity-page_toolbar" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_pagination, {
          currentPage: _unref(bindData).rssActivityCompanyPageParams.curPage,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).rssActivityCompanyPageParams.curPage) = $event)),
          "page-size": _unref(bindData).rssActivityCompanyPageParams.pageSize,
          "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).rssActivityCompanyPageParams.pageSize) = $event)),
          "page-sizes": [10, 20, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _unref(bindData).rssActivityCompanyPageResult.totalCount,
          "onUpdate:total": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).rssActivityCompanyPageResult.totalCount) = $event)),
          onSizeChange: handleSizeChangeEvent,
          onCurrentChange: handleCurrentChangeEvent
        }, null, 8, ["currentPage", "page-size", "total"])
      ]),
      _: 1
    })
  ]))
}
}

})